(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class MenuAccordion extends HTMLElement {
    constructor() {
      super();

      this.onClickListener = this._onClick.bind(this);
    }
    connectedCallback() {
      this.querySelector('.new-footer__menu-title').addEventListener('click', this.onClickListener);
    }
    _open() {
      this.classList.add('open');
    }
    _close() {
      this.classList.remove('open');
    }
    _isOpened() {
      return this.classList.contains('open') === true;
    }
    _onClick(e) {
      e.preventDefault();

      if (window.innerWidth < 1024) {
        if (this._isOpened()) {
          this._close();
        } else {
          this._open();
        }
      }
    }
  }
  if (!window.customElements.get('menu-accordion')) {
    window.customElements.define('menu-accordion', MenuAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
